import { ElementType, PropsWithChildren, ReactNode } from "react";
import { useLocation } from "react-router-dom";

import { useMobile } from "@krea/customer-features/hooks";
import Footer from "@krea/customer-features/shared-components/app/footer";
import { twMerge } from "@krea/shared/design-system/tailwind-utils";

import { Header } from "../header";

interface ILayoutProps {
  MiddleNavbarComponent?: ElementType;
  applicationSelector: ReactNode;
}

export const Layout = ({
  children,
  MiddleNavbarComponent,
  applicationSelector,
}: PropsWithChildren<ILayoutProps>) => {
  const { pathname } = useLocation();

  const isApplicationForm = pathname === "/application/";
  const isPreliminaryBidForm = pathname.includes("/amount-estimator");
  const isMobile = useMobile();

  return (
    <div className="tw-flex tw-h-full tw-w-full tw-flex-col tw-overflow-hidden">
      <Header
        MiddleNavbarComponent={!isMobile ? MiddleNavbarComponent : undefined}
        applicationSelector={applicationSelector}
      />
      <main
        className={twMerge(
          {
            "tw-mt-16": (isApplicationForm && isMobile) || isPreliminaryBidForm,
          },
          {
            "tw-bg-white lg:tw-pt-[125px] tw-pt-[56px]": !(
              (isApplicationForm && isMobile) ||
              isPreliminaryBidForm
            ),
          },

          "tw-grow tw-shrink-0",
        )}
      >
        {children}
      </main>
      <Footer />
    </div>
  );
};
